export const CATEGORY_TYPES = {
  ProfessionalDevelopment: "Professional Development",
  Profile: "Profile",
  LessonPlan: "Lesson Plan",
  MakerResource: "Maker Resource",
  LessonMaterials: "Makercart Activities - Lesson Materials",
  Onboarding: "Onboarding",
};

export const CATEGORY_FOR_OPTIONS = [
  { text: "All", value: "all" },
  {
    text: "Professional Development",
    value: CATEGORY_TYPES.ProfessionalDevelopment,
  },
  { text: "Profile", value: CATEGORY_TYPES.Profile },
  { text: "Lesson Plan", value: CATEGORY_TYPES.LessonPlan },
  {
    text: "Makercart Activities - Lesson Materials",
    value: CATEGORY_TYPES.LessonMaterials,
  },
  {
    text: "Onboarding",
    value: CATEGORY_TYPES.Onboarding,
  },
];

export const LOCALE_STORAGE_KEY = "eddy-locale-preference";

export const CLIENT_UID_STORAGE_KEY = "eddy-client-uid";

export const MAKER_APPROACH_DETAIL = {
  "tinker to discover": {
    title: "Tinker to Discover",
    description:
      "In this approach developed by MakerEd, learners develop initial understanding through hands-on exploration. Short-term outcomes and paths may be different for individuals or groups of learners",
  },
  "make to learn": {
    title: "Make to Learn",
    description:
      "In this approach developed by MakerEd, learners build, deepen, or cement understanding by making. The educator defines the learning goals and provides structure, scaffolds, and support for learners.",
  },
  "application project": {
    title: "Application Project",
    description:
      "In this approach developed by MakerEd, learners apply understanding in order to make and have the opportunity to demonstrate—and, in the process, deepen—learning. Educators can use made artifacts in order to assess learning.",
  },
};

export const MAKERCART_SEQUENCE_STATE = {
  View: "View/Edit",
  Process: "Login/Signup/Guest Selection",
  Complete: "Quote Generated",
};

export const USER_ROLE_GROUP = {
  Admin: 1,
  Trainer: 6,
  Teacher: 2,
};
